import type { SourcingStrategyApi } from './types';

export const isSourcingStrategyTransitionAllowed = (
  currentStrategy: SourcingStrategyApi | null | undefined,
  requestedStrategy: SourcingStrategyApi,
) => {
  if (!currentStrategy || currentStrategy === requestedStrategy) {
    return true;
  }

  return (
    requestedStrategy === 'Agent' &&
    (currentStrategy === 'Worker' || currentStrategy === 'Scout')
  );
};
